"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const reports_1 = require("companion-app-components/flux/reports");
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const selectors_1 = require("data/spending/selectors");
const selectors_2 = require("data/reports/selectors");
const pieChart_1 = __importDefault(require("containers/Reports/components/pieChart"));
const DateRangeMenu_1 = require("containers/Spending/DateRangeMenu");
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const pie_chart_svg_1 = __importDefault(require("assets/zero-state-images/pie-chart.svg"));
const utils_1 = require("utils/date/utils");
const helpers_1 = require("../helpers");
const utils_2 = require("./utils");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const nullFunction = () => { };
const rootCriteria = immutable_1.List.of(selectors_1.ROOT_CRITERIA);
const SpendingByCategory = (props) => {
    const { dateRange = 'This Month', totalSpend, popFilterHistory } = props;
    const { classes, theme } = useStyles();
    const navigate = (0, react_router_1.useNavigate)();
    const sliceJustClickedRef = React.useRef(false);
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const webFirstCatUncategorize = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('categorizeUncategorizedFromSpending'));
    const accountsById = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getReportableAccountsById(state));
    const spendingReportData = (0, react_redux_1.useSelector)((state) => reports_1.reportsSelectors.getReportForDisplay(state, {
        reportName: 'spending',
        dateRange: (0, utils_1.getPredefinedRange)({ value: 'MONTH_TO_TODAY' }),
        timeStep: 'days',
        isOverTime: false,
        chartType: 'pie',
        groupBy: 'category',
        pageInitialized: true,
        subSelector: selectors_2.getIncomeSpendingReportForDisplay,
    }));
    const colorsFromTheme = (((theme || {}).palette || {}).data || {}).sequence1 || [];
    const spendingData = (0, utils_2.buildSpendingByCategoryData)(spendingReportData, colorsFromTheme, accountsById);
    const categorySpending = spendingData.byCategory;
    const categoryTotalSpend = spendingData.total;
    const uncategorizedTransactions = spendingData.uncategorizedTxns;
    const navigateToSpendingWithCriteria = (filterCriteria) => {
        sliceJustClickedRef.current = true;
        setTimeout(() => { sliceJustClickedRef.current = false; }, 0);
        navigate({
            pathname: '/reports/spending/by-category/total',
            search: filterCriteria.parentCoaNodeId ? `?selectCategory=${filterCriteria.parentCoaNodeId}` : '',
        });
    };
    const onSliceClick = (filterCriteria) => {
        navigateToSpendingWithCriteria(filterCriteria);
    };
    const navigateDirectlyToSpending = (e) => {
        e.stopPropagation();
        navigate('/reports/spending/by-category/total');
    };
    const navigateToSpending = (e) => {
        e.stopPropagation();
        if (sliceJustClickedRef.current) {
            sliceJustClickedRef.current = false;
            return;
        }
        // allow clicks on legend area even if not on a legend item proper.
        if (e.target.className && typeof e.target.className === 'string' && e.target.className.indexOf('Connect(QCurrency)') !== -1) {
            navigate('/reports');
            return;
        }
        // allow clicks on the center of the pie chart
        if (e.target.className && typeof e.target.className === 'object' && e.target.tagName === 'rect') {
            navigate('/reports/spending/by-category/total');
            return;
        }
        // default: treat as a card-level click to go to spending
        navigate('/reports/spending/by-category/total');
    };
    const dataIsNull = () => totalSpend === null || categorySpending === null || categorySpending[0].x === 'Loading...';
    const dataIsEmpty = () => !dataIsNull() && categoryTotalSpend === 0;
    const view = (0, helpers_1.computeViewState)(dataIsNull, dataIsEmpty, hasReportableAccounts);
    const rootStyle = { cursor: view === 'main' || view === 'empty' ? 'pointer' : 'auto' };
    return (<div className={classes.root} onClick={navigateToSpending} onKeyPress={navigateToSpending} style={rootStyle} role="presentation">
      {view === 'loading' && <LoadingView_1.default />}
      {view === 'zero' && (<ZeroStateView_1.default icon={pie_chart_svg_1.default} size="small" secondary={['Sync your financial institutions to ', <br key="br"/>, 'see your top trending categories.']}/>)}
      {view === 'empty' && (<ZeroStateView_1.default size="small" onClick={navigateDirectlyToSpending} icon={pie_chart_svg_1.default} primary="No Spending" secondary={[
                'It looks like you haven',
                <span key="quote">&rsquo;</span>,
                't spent any money this month. ',
                <span key="click" className={classes.link}>
              Click here
            </span>,
                ' to choose a different date range.',
            ]}/>)}
      {view === 'main' && (<pieChart_1.default id="chart-div-spending-by-category-2" isDashboard spending={categorySpending} totalSpend={categoryTotalSpend} dateRange={(0, DateRangeMenu_1.intervalForRange)(dateRange)} onSliceClick={onSliceClick} onBreadcrumbClick={nullFunction} popFilterHistory={popFilterHistory} className={classes.graph} getFilterCriteriaWithColor={(filterCriteria, color) => (new selectors_1.CategoryFilterCriteria(filterCriteria.parentCoaNodeId, filterCriteria.coaNodeSet, filterCriteria.name, color, filterCriteria.topLevelOnly))} filterHistory={rootCriteria} active uncategorizedTransactions={webFirstCatUncategorize && uncategorizedTransactions}/>)}
    </div>);
};
exports.default = SpendingByCategory;
